class SearchBar {
  constructor(configs) {
    this.configs = configs;
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(this.configs.selectors.searchBar);
    return container ? {
      container,
      clearButton: container.querySelector(this.configs.selectors.clearButton),
      searchInput: container.querySelector(this.configs.selectors.searchInput)
    } : {};
  }

  _setupEventListeners() {
    this.elements.clearButton.addEventListener('click', this._handleClearButtonClick);
    this.elements.searchInput.addEventListener('input', debounce(() => {
      this._onSearchInputChange();
    }, 300).bind(this));
  }

  _toggleClearButton(show) {
    if (show) {
      this.elements.clearButton.classList.add(this.configs.classes.active);
    } else {
      this.elements.clearButton.classList.remove(this.configs.classes.active);
    }
  }

  _onSearchInputChange() {
    if (this.elements.searchInput.value.trim() === '') {
      this._toggleClearButton(false);
    } else {
      this._toggleClearButton(true);
    }
  }

  _emptySearchInput() {
    this.elements.searchInput.value = '';
    this.elements.searchInput.dispatchEvent(new Event('input', {
      bubbles: true,
      cancelable: true
    }));
    this._toggleClearButton(false);
  }

  _handleClearButtonClick = () => {
    this._emptySearchInput();
  }
}
